<template>
  <el-dialog
    title="结算"
    :visible.sync="visible"
    width="500px"
    :before-close="handleClose"
    @close="handleClose">

    <div class="settlement-form">
      <div class="form-row">
        <label class="form-label">采购日期：</label>
        <span class="form-value">{{ formatDate(purchaseData.date) }}</span>
        <el-button type="text" size="mini" @click="handleViewDetail" style="margin-left: 10px;"><i class="el-icon-document"></i> 查看明细</el-button>
      </div>

      <div class="form-row">
        <label class="form-label">采购金额：</label>
        <span class="form-value">¥ {{ purchaseData.amount.toFixed(2) }}</span>
      </div>

      <div class="form-row">
        <label class="form-label">结算金额：</label>
        <span class="form-value settlement-amount">¥ {{ purchaseData.settlementAmount ? purchaseData.settlementAmount.toFixed(2) : '0.00' }}</span>
      </div>

      <div class="form-row">
        <label class="form-label">当前状态：</label>
        <el-tag type="success">已结算</el-tag>
      </div>

      <div class="form-row">
        <label class="form-label">备注：</label>
        <div class="remark-content">
          {{ purchaseData.remark || '-' }}
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'StlPurchaseView',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    purchaseData: {
      type: Object,
      default: () => ({
        date: '',
        amount: 0,
        settlementAmount: 0,
        remark: '',
        userId: null
      })
    }
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      const month = date.getMonth() + 1
      const day = date.getDate()
      return `${month}月${day}日`
    },

    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    handleViewDetail() {
      this.$emit('view-detail')
    }
  }
}
</script>

<style scoped>
.settlement-form {
  padding: 20px 0;
}

.form-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  min-height: 32px;
}

.form-label {
  width: 100px;
  text-align: right;
  margin-right: 12px;
  color: #333;
  font-size: 14px;
  flex-shrink: 0;
}

.form-value {
  color: #666;
  font-size: 14px;
}

.settlement-amount {
  color: #67C23A;
  font-weight: bold;
}

.remark-content {
  flex: 1;
  margin-left: 8px;
  padding: 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  color: #606266;
  font-size: 14px;
  line-height: 1.5;
  min-height: 80px;
  word-break: break-all;
}

.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/stl/StlPurchaseView.vue